import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

// Backend resource path is @Path("web/workshop/estimates/..."), mounted under servlet /web/*
const BASE_URL = `${BEPI_API.workshop}/estimates`;

export const WorkshopEstimateRespondApi = {
  // Buscar dados da estimativa
  getEstimateDetails: (estimateId) => axios.get(`${BASE_URL}/${estimateId}`),
  
  // Buscar dados do cliente
  getClientDetails: (companyId) => axios.get(`${BASE_URL}/companies/${companyId}`),
  
  // Buscar catálogo de serviços/peças
  getServicesCatalog: () => axios.get(`${BASE_URL}/services/catalog`),
  
  // Enviar resposta da estimativa
  submitEstimateResponse: (estimateId, responseData) => axios.post(`${BASE_URL}/${estimateId}/respond`, responseData),
  
  // Criar orçamento
  createBudget: (budgetData) => axios.post(`${BASE_URL}/budgets`, budgetData)
};
